import {FC} from 'react'
import {ReportValoration} from '../ReportValuation'
const HeaderReportValorationPanel: FC = () => {
  return <ReportValoration />
}

export {HeaderReportValorationPanel}
